import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, } from '@angular/forms';
import { LoopBackFilter } from '../../../sdk/models';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { PlatformApp } from '../../../services/app.service';
import { NotificationsService } from 'angular2-notifications';
import { newaccountfields, updateuserdata, updateuserpassword } from "../../../formfields";
import { Account } from '../../../sdk/models';
import { AccountApi, EntityrecordApi, PicklistApi } from '../../../sdk/services/custom';
import { FormlyFieldConfig } from 'ng-formly';
import { isEmpty, isNotEmpty } from '../../../utils/util';

@Component({
    selector: 'user-list',
    templateUrl: './user-list.component.html',
    providers: [],
    styleUrls: ['./user-list.component.scss']

})

export class UserListComponent implements OnInit, OnDestroy {
    @Input() entityrecordid: string;
    @Input() entityid: string;
    @Input() accounttype: string;
    currentuser: any;
    @ViewChild('updateModal') public updateModal: ModalDirective;
    @ViewChild('passwordModal') public passwordModal: ModalDirective;

    private _RESTAURANT = '5825d3e5f009c4bc37fd7ba1';
    private _FOODCOURT = '58ba6d7387613c1a410c30bf';
    private _APARTMENT = '5f2134326609786b9a629e38';
    private _CORPORATE = '5e1dbe1f66edc031235a09a3';
    private _VENDOR_COMPANY = '5ad7058cb30e4731059f8ddd';
    private _LEGAL_ENTITY = '639977f2711f493d50ccc7ee';
    private _DEPARTMENT = '639978e315127145ac5bf557';
    private _CITY = '5825d6fcf009c4bc37fd7bb5';

    form: FormGroup;
    accounts: any;
    subscriptions: any = [];
    newaccountfields: FormlyFieldConfig[] = _.cloneDeep(newaccountfields);
    updateuserdata: FormlyFieldConfig[] = _.cloneDeep(updateuserdata);
    updateuserpassword: FormlyFieldConfig[] = _.cloneDeep(updateuserpassword);
    newAccount: Account = new Account();
    notifyOptions = PlatformApp.getNotificationOptions();
    filter: LoopBackFilter = <LoopBackFilter>{ 'where': {} };
    showError: boolean = false;

    _edit_acc: any;

    outlet_options = [];
    outlets = [];
    foodcourts = [];
    cities = [];
    legal_entities = [];
    departments = [];
    apartments = [];

    constructor(private _AccountApi: AccountApi, private _PicklistApi: PicklistApi, private _LoopBackAuth: LoopBackAuth, private fb: FormBuilder,
        private _EntityrecordApi: EntityrecordApi, private _NotificationsService: NotificationsService) {
        this.loadroles();
        this.loadRelatedEntities();
    }

    ngOnInit(): void {
        // if (this.entityrecordid && this.entityid == this._VENDOR_COMPANY) {
        //     let index = this.newaccountfields.findIndex(f => f.key == 'password');
        //     if (index != -1) this.newaccountfields.splice(index, 1);
        // }
        this.newaccountfields.push({
            key: 'set_password',
            className: 'col-sm-3',
            type: 'checkbox',
            defaultValue: false,
            templateOptions: {
                label: 'Admin Can set password for this user',
                required: false
            }
        })
        this.updateuserdata.push({
            key: 'set_password',
            className: 'col-sm-3',
            type: 'checkbox',
            defaultValue: false,
            templateOptions: {
                label: 'Admin Can set password for this user',
                required: false
            }
        })
        if (this.entityrecordid && this.entityid == this._FOODCOURT) {
            this.updateuserdata.push({
                key: 'linked_outlets',
                className: 'col-sm-12',
                type: 'select-component',
                templateOptions: {
                    label: 'Select Outlets',
                    multiple: true,
                    enableSelectAll: true,
                    options: [{ label: 'All', value: 'all' }],
                }
            })
            // 
        }
        if (this.entityrecordid && this.entityid == this._CORPORATE) {
            this.updateuserdata.push({
                key: 'linked_outlets',
                className: 'col-sm-12',
                type: 'select-component',
                templateOptions: {
                    label: 'Select Outlets',
                    multiple: true,
                    enableSelectAll: true,
                    options: [{ label: 'All', value: 'all' }],
                }
            })
            this.updateuserdata.push({
                key: 'can_manage_visitors',
                className: 'col-sm-3',
                type: 'checkbox',
                defaultValue: false,
                templateOptions: {
                    label: 'Can Manage Visitors?',
                    required: false
                }
            })
            this.updateuserdata.push({
                key: 'cities',
                className: 'col-sm-12',
                type: 'select-component',
                templateOptions: {
                    label: 'Select city',
                    multiple: true,
                    enableSelectAll: true,
                    options: [],
                }
            })
            this.updateuserdata.push({
                key: 'departments',
                className: 'col-sm-12',
                type: 'select-component',
                templateOptions: {
                    label: 'Select Department',
                    multiple: true,
                    enableSelectAll: true,
                    options: [],
                }
            })
            this.updateuserdata.push({
                key: 'legal_entities',
                className: 'col-sm-12',
                type: 'select-component',
                templateOptions: {
                    label: 'Select Legal Entity',
                    multiple: true,
                    enableSelectAll: true,
                    options: [],
                }
            })

            this.newaccountfields.push({
                key: 'can_manage_visitors',
                className: 'col-sm-3',
                type: 'checkbox',
                defaultValue: false,
                templateOptions: {
                    label: 'Can Manage Visitors?',
                    required: false
                }
            });

            // For corporate users, we should not ask password to be set from backend
            let index = this.newaccountfields.findIndex(f => f.key == 'password');
            if (index != -1) this.newaccountfields.splice(index, 1);
            index = this.newaccountfields.findIndex(f => f.key == 'set_password');
            if (index != -1) this.newaccountfields.splice(index, 1);
            index = this.updateuserdata.findIndex(f => f.key == 'set_password');
            if (index != -1) this.updateuserdata.splice(index, 1);
        }
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.form = this.fb.group({});
        this.refreshUsers();
        this.newAccount = new Account();
        console.log(this.newaccountfields)
    }

    loadroles(): void {
        let accountFields = [...this.newaccountfields];
        let updateUserData = [...this.updateuserdata];
        this._PicklistApi.findById('5c45b9e06c0bbc57b5d43a66')
            .toPromise()
            .then(picklist => {
                if (picklist && picklist['options'].length) {
                    _.find(this.newaccountfields, { 'key': 'role' })
                        .templateOptions.options = [...picklist['options']];

                    _.find(this.updateuserdata, { 'key': 'role' })
                        .templateOptions.options = [...picklist['options']];
                }
            });
        this.newaccountfields = accountFields;
        this.updateuserdata = updateUserData;
    }

    loadRelatedEntities() {
        let updateUserData = [...this.updateuserdata];
        // console.log(this.entityid);
        if (this.entityid === this._FOODCOURT) { // Foodcourt
            this._EntityrecordApi.find({ where: { entityId: this._RESTAURANT, 'data.foodcourt': this.entityrecordid } })
                .toPromise()
                .then(outlets => {
                    // console.log(outlets);
                    this.outlets = outlets;
                    this.outlets.forEach((_o: any) => {
                        if (!this.outlet_options.some(o => o.value == _o.id)) this.outlet_options.push({ value: _o.id, label: _o.data.label || _o.data.name });
                    });
                    let _ent = _.find(updateuserdata, { 'key': 'linked_outlets' });
                    if (_ent) _ent.templateOptions.options = [{ label: 'All', value: 'all' }, ...this.outlet_options];
                    this.updateuserdata = updateUserData;
                }).catch(err => console.error(err))
        } else if (this.entityid === this._APARTMENT) { // Apartment
            this._EntityrecordApi.find({ where: { entityId: this._RESTAURANT, 'data.apartment': this.entityrecordid } })
                .toPromise()
                .then(outlets => {
                    // console.log(outlets);
                    this.outlets = outlets;
                    this.outlets.forEach((_o: any) => {
                        if (!this.outlet_options.some(o => o.value == _o.id)) this.outlet_options.push({ value: _o.id, label: _o.data.label || _o.data.name });
                    });
                    let _ent = _.find(updateuserdata, { 'key': 'linked_outlets' });
                    if (_ent) _ent.templateOptions.options = [{ label: 'All', value: 'all' }, ...this.outlet_options];
                    this.updateuserdata = updateUserData;
                }).catch(err => console.error(err))

        } else if (this.entityid === this._CORPORATE || this.entityid === this._VENDOR_COMPANY) { // Corporate or Vendor Company
            this._EntityrecordApi.find({
                where: {
                    or: [{ entityId: this._RESTAURANT, 'data.company': this.entityrecordid },
                    { entityId: this._RESTAURANT, 'data.companyid': this.entityrecordid },
                    { entityId: this._FOODCOURT, 'data.company': this.entityrecordid },
                    { entityId: this._FOODCOURT, 'data.companyid': this.entityrecordid },
                    { entityId: this._DEPARTMENT, 'data.parentId': this.entityrecordid },
                    { entityId: this._LEGAL_ENTITY, 'data.parentId': this.entityrecordid },
                    { entityId: this._CITY }]
                }
            })
                .toPromise()
                .then(result => {
                    const outlets = result.filter((_r: any) => _r.entityId === this._RESTAURANT);
                    const foodcourts = result.filter((_r: any) => _r.entityId === this._FOODCOURT);
                    this.foodcourts = _.cloneDeep(foodcourts);
                    if (this.entityrecordid && this.entityid == this._CORPORATE) {
                        const departments = result.filter((_r: any) => _r.entityId === this._DEPARTMENT);
                        this.departments = _.cloneDeep(departments);
                        let _ent = _.find(this.updateuserdata, { 'key': 'departments' });
                        if (_ent) _ent.templateOptions.options = [...this.departments.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];

                        const legal_entities = result.filter((_r: any) => _r.entityId === this._LEGAL_ENTITY);
                        this.legal_entities = _.cloneDeep(legal_entities);
                        _ent = _.find(this.updateuserdata, { 'key': 'legal_entities' });
                        if (_ent) _ent.templateOptions.options = [...this.legal_entities.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];

                        const cities = result.filter((_r: any) => _r.entityId === this._CITY);
                        this.cities = _.cloneDeep(cities);
                        _ent = _.find(this.updateuserdata, { 'key': 'cities' });
                        if (_ent) _ent.templateOptions.options = [...this.cities.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];
                    }
                    if (isNotEmpty(foodcourts)) {
                        foodcourts.forEach((_f: any) => _f.data.label = 'FC: ' + _f.data.name);
                        return this._EntityrecordApi.find({
                            where: { entityId: this._RESTAURANT, 'data.foodcourt': { inq: foodcourts.map((_f: any) => _f.id) } }
                        })
                            .toPromise()
                            .then(o_result => {
                                o_result.forEach((_o: any) => {
                                    let f: any = foodcourts.find((_f: any) => _f.id === _o.data.foodcourt);
                                    if (f) {
                                        _o.data.foodcourtname = f.data.name;
                                        _o.data.label = _o.data.foodcourtname + ' > ' + _o.data.name
                                    }
                                })
                                o_result.forEach((_o: any) => {
                                    const index = result.findIndex((_ri: any) => _ri.id === _o.id);
                                    if (index == -1) { result.push(_o) }
                                    else { result[index] = _o }
                                })
                                let _r = [..._.cloneDeep(foodcourts), ...o_result, ...outlets];
                                _r = _.uniqBy(_r, 'id');
                                // result.push(...o_result);
                                return _r;
                            })
                            .catch(err => {
                                console.error(err);
                                return [...foodcourts, ...outlets];
                            })
                    } else return outlets;
                })
                .then(outlets => {
                    // console.log(outlets);
                    this.outlets = outlets;
                    // console.log(2, outlets);
                    this.outlets.forEach((_o: any) => {
                        if (!this.outlet_options.some(o => o.value == _o.id)) this.outlet_options.push({ value: _o.id, label: _o.data.label || _o.data.name });
                    });
                    let _ent = _.find(this.updateuserdata, { 'key': 'linked_outlets' });
                    if (_ent) _ent.templateOptions.options = [{ label: 'All', value: 'all' }, ...this.outlet_options];
                    this.updateuserdata = updateUserData;
                }).catch(err => console.error(err))
        }
    }

    adduser(): void {
        if (this.entityid) {
            this.newAccount['entityId'] = this.entityid;
        }
        if (this.entityrecordid) {
            this.newAccount['entityrecordId'] = this.entityrecordid;
        }
        if (this.entityid && this.entityrecordid && isEmpty(this.newAccount['linked_outlets'])) {
            this.newAccount['entities'] = [{ id: this.entityrecordid, typeId: this.entityid }];
        } else if (isNotEmpty(this.newAccount['linked_outlets'])) {
            this.newAccount['entities'].push(...this.newAccount['linked_outlets'].map(_e_id => {
                if (_e_id === 'all') return { id: this.entityrecordid, typeId: this.entityid }
                let _o = this.outlet_options.find(_o => _o.value === _e_id);
                if (_o) return { id: _o.id, typeId: _o.entityId }
                return null;
            }))
        }

        if (this.accounttype) {
            this.newAccount['accounttype'] = this.accounttype;
        }
        if (!this.newAccount['password'] || this.newAccount['password'].length == 0) {
            this.newAccount['password'] = 'Dcm23Cdsfe#$fewf3';
        }

        this._AccountApi.create(this.newAccount).toPromise().then((newaccount) => {
            if (newaccount) {
                this.notify('success', 'Account Created', newaccount.email);
                this.refreshUsers();
                this.form.reset({});
                this.newAccount = new Account();
            }
        }).catch(err => {
            if (err && err.message.includes('Email already exists')) {
                this.notify('error', 'Account exist', `Account with ${this.newAccount.email} already exists in our system`);
            } else {
                this.notify('error', 'Account not created', `Facing some issues in creating Account with ${this.newAccount.email}.`);
            }
        });
    }

    deleteuser(account): void {
        let password = prompt("Enter in the password");
        if (password == "Venturing500") {
            this._deleteuser(account);
        } else {
            alert("That's an invalid password.")
        }
    }
    _deleteuser(account): void {
        this._AccountApi.deleteById(account.id).toPromise().then((result) => {
            if (result) {
                this.notify('success', 'Account Deleted', account.email);
                this.refreshUsers();
                this.form.reset({});
                this.newAccount = new Account();
            }
        });
    }

    editpassword(account): void {
        this.passwordModal.show();
        this.showError = false;
        let userPassword = this.updateuserpassword;

        _.find(userPassword, { 'key': 'id' })
            .formControl.setValue(account.id);

        _.find(userPassword, { 'key': 'password' })
            .formControl.setValue('');

        _.find(userPassword, { 'key': 'confirmpassword' })
            .formControl.setValue('');

        this.updateuserpassword = userPassword;
    }

    edituser(account): void {
        let userData = this.updateuserdata;
        account['linked_outlets'] = account.entities.map(_e => {
            if (_e.id == this.entityrecordid) return 'all';
            return _e.id
        });
        // this.newAccount = account;
        this._edit_acc = account;
        this.updateModal.show();
        this._PicklistApi.findById('5c45b9e06c0bbc57b5d43a66').toPromise()
            .then(picklist => {
                if (picklist && picklist['options'].length) {
                    _.find(userData, { 'key': 'id' })
                        .formControl.setValue(account.id);

                    _.find(userData, { 'key': 'email' })
                        .formControl.setValue(account.email);

                    if (account.can_manage_visitors != null && account.can_manage_visitors != undefined) {
                        _.find(userData, { 'key': 'can_manage_visitors' })
                            .formControl.setValue(account.can_manage_visitors);
                    }

                    _.find(userData, { 'key': 'role' })
                        .formControl.setValue(account.role);
                    _.find(userData, { 'key': 'role' })
                        .templateOptions.options = [...picklist['options']];
                }
                const _l_o = _.find(userData, { 'key': 'linked_outlets' });
                if (this.outlet_options && this.outlet_options.length > 0) {
                    _l_o.formControl.setValue(account.entities.map(_e => {
                        if (_e.id == this.entityrecordid) return 'all';
                        return _e.id
                    }));
                    _l_o.templateOptions.options = [{ label: 'All', value: 'all' }, ...this.outlet_options];
                } else if (_l_o) {
                    _l_o.templateOptions.options = [];
                    _l_o.templateOptions.setValue([]);
                }
                const _legal_entities = _.find(userData, { 'key': 'legal_entities' });
                if (this.legal_entities && this.legal_entities.length > 0 && account.legal_entities && account.legal_entities.length > 0) {
                    _legal_entities.formControl.setValue(account.legal_entities);
                }
                _legal_entities.templateOptions.options = [...this.legal_entities.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];
                const _departments = _.find(userData, { 'key': 'departments' });
                if (this.departments && this.departments.length > 0 && account.departments && account.departments.length > 0) {
                    _departments.formControl.setValue(account.departments);
                }
                _departments.templateOptions.options = [...this.departments.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];
                const _cities = _.find(userData, { 'key': 'cities' });
                if (this.cities && this.cities.length > 0 && account.cities && account.cities.length > 0) {
                    _cities.formControl.setValue(account.cities);
                }
                _cities.templateOptions.options = [...this.cities.map(_o => { return { value: _o.id, label: _o.data.label || _o.data.name } })];

            });

        this.updateuserdata = userData;
    }

    cancelEdit() {
        this.updateModal.hide();
        this.form.reset({});
        this.newAccount = new Account();
    }

    updateuser(): void {
        console.log(this.newAccount, this._edit_acc);
        const acc = this.newAccount;
        const l = acc['linked_outlets'];
        const c_m_v = acc['can_manage_visitors'];
        if (l) {
            acc['entities'] = l.map(_e_id => {
                if (_e_id === 'all') return { id: this.entityrecordid, typeId: this.entityid }
                let _o = this.outlets.find(_o => _o.id === _e_id);
                if (_o) return { id: _o.id, typeId: _o.entityId }
                let _f = this.foodcourts.find(_f => _f.id === _e_id);
                if (_f) return { id: _f.id, typeId: _f.entityId }
                return null;
            })
        } else acc['entities'] = [];
        acc['entities'] = acc['entities'].filter(_a => _a);
        this._AccountApi.patchAttributes(acc.id, { role: acc['role'], entities: acc['entities'], can_manage_visitors: acc['can_manage_visitors'], departments: acc['departments'], cities: acc['cities'], legal_entities: acc['legal_entities'] })
            .toPromise()
            .then(result => {
                if (result) {
                    this.updateModal.hide();
                    this.notify('success', 'User Details Updated', acc.email);
                    this.refreshUsers();
                    this.form.reset({});
                    this.newAccount = new Account();
                }
            })
    }

    updatepassword(): void {
        const acc = this.newAccount;
        if (acc.password === acc.confirmpassword) {
            this.subscriptions.push(this._AccountApi.patchAttributes(acc.id, { password: acc.password })
                .subscribe(result => {
                    if (result) {
                        this.passwordModal.hide();
                        this.notify('success', 'Password updated', acc.email);
                        this.refreshUsers();
                        this.form.reset({});
                        this.newAccount = new Account();
                        this.showError = false;
                    }
                })
            );
        } else {
            this.showError = true;
        }
    }

    refreshUsers(): void {
        // this.filter.where = { 'entities.id': this.entityrecordid };
        this.filter.where["appId"] = this.currentuser.appId;
        if (this.entityid) {
            this.filter.where["entityId"] = this.entityid;
        }
        if (this.entityrecordid) {
            this.filter.where["entityrecordId"] = this.entityrecordid;
        }
        if (this.accounttype) {
            this.filter.where["accounttype"] = this.accounttype;
        }
        this.subscriptions.push(this._AccountApi.find(this.filter).subscribe((accounts) => {
            if (accounts) {
                this.accounts = accounts;
            }
        }));
        this.loadroles();
        this.loadRelatedEntities();
    }

    ngOnDestroy() {
        for (let i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }
    }

    notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/user-list/user-list.component.ts